const API_ROUTES = {
  REFRESH_TOKEN: `/user-management/v1/refresh/authtoken`,
  LOGIN: `/user-management/v1/login/password`,
  NON_LOGIN: `/user-management/v1/generate/nonLogin`,
  DIAIKIN_LOGIN: `/user-management/v1/login/daikincity`,
  LOGOUT: `/user-management/v1/logout`,
  FORGOT_PASSWORD: ({ userName }) =>
    `/user-management/v1/reset/password/${userName}`,
  RESET_PASSWORD: `/user-management/v1/save/password`,
  ADD_NEW_USER: `user-management/v1/add/newuser`,
  UPDATE_USER: `user-management/v1/userprofile`,
  UPDATE_USER_CONTENT: `user-management/v1/user/content`,
  ADD_BUILDING: `user-management/v1/userbuilding`,
  GET_USER_PROFILE: id => `user-management/v1/userprofile/${id}`,
  GET_USER: ({ params }) => `user-management/v1/relation/users/${params}`,
  GET_BUILDING: ({ params }) => `user-management/v1/userbuilding/${params}`,
  SEARCH_USER: ({ params }) => `/user-management/v1/search/user/${params}`,
  ADD_ASSOCIATE: `/user-management/v1/userprofile`,
  USER_VALIDATION: ({ params }) => `/user-management/v1/credvalidate${params}`,
  GET_BRAND: ({ id }) => `/user-management/v1/brand/${id}`,
  GET_ALL_BRAND: ({ params }) => `/user-management/v1/all/brand/${params}`,
  GET_IMAGE_FILE: ({ params }) => `/user-management/v1/file${params}`,
  DELETE_IMAGE_FILES: ({ params }) => `/user-management/v1/files${params}`,
  ADD_BRAND: ({ params }) => `user-management/v1/brand${params}`,
  SEARCH_BRAND: ({ params }) => `/user-management/v1/search/brand/${params}`,
  GET_JOB_LIST: ({ params }) => `/job-management/v1/job/${params}`,
  SEARCH_JOB_LIST: ({ params }) => `/job-management/v1/search/job/${params}`,
  GET_ERROR_CODE: ({ pageNo, params }) =>
    `/job-management/v1/job/model/errorcode/${pageNo}${params}`,
  SEARCH_ERROR_CODE: ({ pageNo, params }) =>
    `/job-management/v1/search/job/model/errorcode/${pageNo}${params}`,
  GET_JOB_DETAILS: ({ params }) => `/job-management/v1/job${params}`,
  FISCAL_YEARS: `/job-management/v1/fiscalyear`,
  JOBS_UPDATE: '/job-management/v1/job',
  GET_EQUIPMENT: ({ params }) => `/user-management/v1/all/ein/${params}`,
  SEARCH_EQUIPMENT: ({ params }) => `/user-management/v1/search/ein/${params}`,
  GET_ADDRESS_DATA: ({ params }) =>
    `/dataviz-management/v1/statecitylist${params}`,
  GET_EQUIPMENT_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/${params}`,
  GET_EQUIPMENT_PIE_CHART_DATA: ({ params }) =>
    `/dataviz-management/v1/piechart${params}`,
  GET_TOTAL_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/user/job/total${params}`,
  GET_FE_USER_DATA: ({ params }) =>
    `/dataviz-management/v1/brand/user/jobs/${params}`,
  ADD_ERROR_CODE: `/user-management/v1/errorcode`,
  GET_FILTER_USER_DATA: ({ userType, pageNo }) =>
    `/dataviz-management/v1/filter/${userType}/${pageNo}`,
  GET_SEARCH_FILTER_DATA: ({ userType, pageNo, search }) =>
    `/dataviz-management/v1/filter/search/${userType}/${pageNo}?search=${search}`,
  GET_BUILDING_DETAILS: ({ buildingId }) =>
    `/dataviz-management/v1/building/${buildingId}`,
  GET_EQUIPMENT_DETAILS: ({ buildingId, equipmentId }) =>
    `/dataviz-management/v1/building/${buildingId}/equipment/${equipmentId}`,
  GET_REPORT: ({ jobId, jobType }) =>
    `/job-management/v1/report?jobId=${jobId}&jobType=${jobType}`,
  GET_BRAND_TOTAL: ({ params }) =>
    `/dataviz-management/v1/brand/jobs/total${params}`,
  SHARE_REPORT: `/job-management/v1/email-sms`,
  UPDATE_REPORT: `/job-management/v1/updation/report`,
  REFRIGERANT_LIST: `/job-management/v1/cylinder/info`,
  GET_STATE_REGION: `/user-management/v1/state/region`,
  GET_MANAGE_REGION: `user-management/v1/regions`,
  MANAGE_REGION: `/user-management/v1/region`,
  UPDATE_REGION: `/user-management/v1/region/name`,
  GET_TILES: ({ params }) => `/dataviz-management/v1/dashboard/tiles${params}`,
  GET_PIE_CHART: ({ params }) =>
    `/dataviz-management/v1/dashboard/piechart${params}`,
  GET_ERROR_CODE_TABLE: ({ params }) =>
    `/dataviz-management/v1/dashboard/table/${params}`,
  GET_BAR_CHART: ({ params }) =>
    `/dataviz-management/v1/dashboard/barchart/${params}`,
  GET_TOTAL_JOBS: ({ params }) =>
    `/dataviz-management/v1/dashboard/totalJobs${params}`,
  GET_BUBBLE_CHART: ({ params }) =>
    `/dataviz-management/v1/dashboard/bubblechart${params}`,
  GET_COUNTRY_STATE: ({ params }) =>
    `/dataviz-management/v1/dashboard/statecitylist${params}`,
  GET_EQUIPMENT_LIST: ({ params }) => `/job-management/v1/equipment/${params}`,
  ADD_EQUIPMENT: `/job-management/v1/equipment`,
  ALL_PRODUCT_SERIES: ({ params }) =>
    `/user-management/v1/product/series${params}`,
  EIN_VALIDATE: ({ params }) => `/job-management/v1/ein/validate${params}`,
}
export default API_ROUTES
